import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { PlansTable, type Plan } from '@platzi/micro-ui.plans';
import { USER_TYPE } from './utils/constants';
import styles from './PricingTable.module.sass';


export const PricingTable = () => {
  const isLogged = useSelector((state) => state.get('header').get('isLogged'));
  const user = useSelector((state) => state.get('header')?.get('userInfo'), shallowEqual).toJS();
  const paywalls = useSelector((state) => state.get('plans'), shallowEqual).toJS();

  const isFree = user?.userType === 'free';

  const userType = USER_TYPE;

  const onClickPlan = (plan: Plan) => {
    window.location.href = plan?.buy_url || `/comprar/${plan?.slug}`;
  };

  const messages = {
    title: 'Suscríbete y potencia tu futuro profesional',
    subtitle: 'Contenido profesional y actualizado con certificados digitales.',
    disclaimer: 'Nunca subiremos el precio si mantienes tu suscripción activa',
  };

  const showDisclaimer = paywalls?.country_code !== 'AR';

  if (!Object.keys(paywalls).length) return null;

  if (isLogged && !isFree) return null;

  return (
    <section className={styles.PricingTable} id="planes">
      <div className="u-wrapper">
        {userType === USER_TYPE && <PlansTable
          plans={paywalls}
          showB2BLink
          showDisclaimer={showDisclaimer}
          showBanner
          onClickPlan={onClickPlan}
          messages={messages}
        />}
      </div>
    </section>
  );
};
